import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { LogisticFeatureDefinition } from '@digiwall/goliath-documents/config';

const routes: Routes = [
  {
    path: 'logistics',
    canMatch: [LogisticFeatureDefinition],
    children: [
      // Logistics routes guarded by the logistics feature only.
      // Routes that additionally require the stock feature live in their own
      // routing module (e.g. GoliathDocumentsInventoryCountDocRoutingModule).
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class GoliathDocumentsLogisticRoutingModule {}
